export default __webpack_public_path__ + "static/media/active-clock-icon-charge.f1f454038aa878909d9dfbad9d15a128.svg";